<h1 mat-dialog-title class="notification-title">
	{{ 'insights.administration.users.reports.title' | translate }}
</h1>
<mat-dialog-content>
	<p class="subheading mat-caption">
		{{ 'insights.administration.users.reports.subtitle' | translate }}
	</p>
	<div cdkDropListGroup style="display: flex">
		<div class="example-container">
			<h5 class="mat-caption" style="font-size: 14px; font-weight: 600">
				{{ 'insights.administration.users.reports.reportstitle' | translate }}
			</h5>

			<div cdkDropList [cdkDropListData]="reports" class="example-list mat-subtitle-2" (cdkDropListDropped)="drop($event)">
				@for (item of reports; track item) {
					<div class="example-box" [ngClass]="{ 'text-italic': item.reportId }" cdkDrag>
						{{ item.name }}
					</div>
				}
			</div>
		</div>

		<div class="example-container example-container-right">
			<h5 class="mat-caption" style="font-size: 14px; font-weight: 600">
				{{ 'insights.administration.users.reports.userreportstitle' | translate }}
			</h5>

			<div cdkDropList [cdkDropListData]="userReports" class="example-list list-right" (cdkDropListDropped)="drop($event)">
				@for (item of userReports; track item) {
					<div class="example-box mat-subtitle-2" [ngClass]="{ 'text-italic': item.reportId === null }" cdkDrag>
						{{ item.name }}
						<mat-icon mat-list-icon class="account-select-icon" svgIcon="{{ selectedDefaultReport === (item.externalId || item.externalUrlId) ? 'acies_star_filled' : 'acies_star' }}" style="margin-left: auto" (click)="selectDefaultReport(item)"></mat-icon>
						<mat-icon mat-list-icon class="account-select-icon" svgIcon="acies_delete" style="margin-left: 8px" (click)="removeUserReport(item)"></mat-icon>
					</div>
				}
			</div>
		</div>
	</div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">
		{{ 'insights.administration.users.reports.cancelbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" cdkFocusInitial (click)="saveUserReports()">
		{{ 'insights.administration.users.reports.savebtn' | translate }}
	</button>
</div>
